module.exports = __webpack_public_path__ + "img/icon_submenu21.2653ed98.svg";